// Session insights for the shared game page. getPuttAssessment is a VERBATIM
// port of puttr-app/components/coach/CoachFunctions.js#getPuttAssessment
// (synced 2026-09-11) so the web page reports the same tendencies the app does.
import { getHoleEntry, getTeeEntry, getMissResult } from './GameFunctions';
import { analyzeRollout, projectRollout, arrivalSpeed, iqr, paceConsistency, DEFAULT_FPS } from './RolloutFunctions';

export const getPuttAssessment = (putts, handedness) => {
  // Pace tendency in rollout inches (0 = dies dead center of the hole).
  let made = 0;
  let left = 0;
  let right = 0;
  let high = 0;
  let low = 0;
  // Pace consistency is measured on arrival speed (one axis for makes,
  // misses and short putts), never on rollout inches; see RolloutFunctions.
  const arrivals = [];
  let slow = 0;
  let fast = 0;

  for (const i in putts){

    const p = putts[i];

    let ballPath = p.ballPath
    let holeBounds = p.holeBounds;
    if (typeof ballPath == "string"){
      ballPath = JSON.parse(p.ballPath);
    }
    if (typeof holeBounds == "string"){
      holeBounds = JSON.parse(p.holeBounds);
    }

    const analysis = analyzeRollout(ballPath, holeBounds);
    const ro = projectRollout(analysis, null, Number(p.made) === 0 ? false : undefined);

    if (ro != null){
      if (ro > 3)
        fast++;
      else if (ro < -3)
        slow++;
    }
    const v = arrivalSpeed(analysis);
    if (v != null) arrivals.push(v);

    if (p.made == 0){

      const m = getMissResult(ballPath, holeBounds);

      if (m == "RIGHT")
        right++;
      else if (m == "LEFT")
        left++;
    }
    else {//made putt
      const he = getHoleEntry(ballPath, holeBounds);
      const te = getTeeEntry(p.distance, p.tee);
      const angDiff = he[2] - te;

      if (angDiff > 0){
        right++;
      }
      else if (angDiff < 0){
        left++;
      }
      //high / low calc
      if (p.tee == 1){ //l2r
        if (angDiff < 0){
          high++;
        }
        else if (angDiff > 0) {
          low++;
        }
      }
      else if (p.tee == 3){ //r2l
        if (angDiff> 0){
          high++;
        }
        else if (angDiff < 0) {
          low++;
        }
      }

      made++;
    }

  }

  // Interquartile range of arrival speed, reported in inches per second at
  // the fleet frame rate. The category comes from the shared cutoffs.
  const speedDispersion = Number((iqr(arrivals) * DEFAULT_FPS).toFixed(1));
  const percentMade = Math.round((made / putts.length) * 100);
  const consistency = paceConsistency(arrivals);

  let pushPull = "none";
  let pushPullPercentage = 0;
  const totalPushPull = right + left;
  if (handedness == "RIGHTY"){
    if (left > right){
      pushPull = "pull";
      pushPullPercentage = Math.round((left / totalPushPull) * 100);
    }
    else if (right > left){
      pushPull = "push";
      pushPullPercentage = Math.round((right / totalPushPull) * 100);
    }
  }
  else if (handedness == "LEFTY"){
    if (left > right){
      pushPull = "push";
      pushPullPercentage = Math.round((left / totalPushPull) * 100);
    }
    else if (right > left){
      pushPull = "pull";
      pushPullPercentage = Math.round((right / totalPushPull) * 100);
    }
  }

  return {
    percentMade: percentMade,
    right: right,
    left: left,
    pushPull: pushPull,
    pushPullPercent: pushPullPercentage,
    high: high,
    low: low,
    speedConsistency: consistency,
    speedDispersion: speedDispersion,
    slow,
    fast,
  };

}
